<template>
  <div class="daily_reservation">
    <div class="top">
      <div class="left container">
        <div class="curved-rectangle">
          <span class="blue_text artistic_font_numbers">{{ data?.car?.application || 0 }}</span>
          条 预约
        </div>
        <div class="curved-rectangle">
          <span class="yellow_text artistic_font_numbers">{{ data?.car?.registration || 0 }}</span>
          条 备案
        </div>
      </div>
      <div class="center" id="daily_reservation_top_circle">车辆</div>
      <div class="right container">
        <div class="curved-rectangle">
          <span class="green_text artistic_font_numbers">{{ data?.car?.agree || 0 }}</span>
          条 通过
        </div>
        <div class="curved-rectangle">
          <span class="red_text artistic_font_numbers">{{ data?.car?.disagree || 0 }}</span>
          条 驳回
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left container">
        <div class="curved-rectangle">
          <span class="blue_text artistic_font_numbers">{{ data?.person?.application || 0 }}</span>
          条 预约
        </div>
        <div class="curved-rectangle">
          <span class="yellow_text artistic_font_numbers">{{ data?.person?.registration || 0 }}</span>
          条 备案
        </div>
      </div>
      <div class="center" id="daily_reservation_bottom_circle">人员</div>
      <div class="right container">
        <div class="curved-rectangle">
          <span class="green_text artistic_font_numbers">{{ data?.person?.agree || 0 }}</span>
          条 通过
        </div>
        <div class="curved-rectangle">
          <span class="red_text artistic_font_numbers">{{ data?.person?.disagree || 0 }}</span>
          条 驳回
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, onUnmounted, defineExpose } from 'vue'
  import { getTodayApplication } from '@/api/dashboard'

  function resize() {
    const parentElement = document.querySelector('.daily_reservation')
    const topCircleElement = document.querySelector(
      '#daily_reservation_top_circle'
    )
    const bottomCircleElement = document.querySelector(
      '#daily_reservation_bottom_circle'
    )

    const parentWidth = parentElement.clientWidth
    const parentHeight = parentElement.clientHeight

    const diameter = Math.min(parentWidth / 3, parentHeight / 3)
    topCircleElement.style.setProperty('--circle-diameter', diameter + 'px')
    bottomCircleElement.style.setProperty('--circle-diameter', diameter + 'px')
  }
  onMounted(resize)

  const data = ref()
  const timer = ref()
  async function fetch() {
    const res = await getTodayApplication()
    if (res.success) {
      data.value = res.data
    }
  }
  onMounted(() => {
    fetch()
    timer.value = setInterval(fetch, 60 * 1000)
  })
  onUnmounted(() => clearInterval(timer.value))

  defineExpose({ resize })
</script>

<style lang="less" scoped>
  .daily_reservation {
    flex: 1;
    display: flex;
    flex-direction: column;

    .blue_text {
      color: rgb(0, 170, 255);
    }
    .green_text {
      color: #00d900;
    }
    .yellow_text {
      color: #d9b500;
    }
    .red_text {
      color: #d90000;
    }
    .left {
      text-align: right;
    }
    .right {
      text-align: left;
    }
    .top,
    .bottom {
      flex: 1;
      display: flex;
      align-items: stretch;
      justify-content: center;

      #daily_reservation_top_circle,
      #daily_reservation_bottom_circle {
        align-self: center;
        --circle-diameter: 0px;
        width: var(--circle-diameter);
        height: var(--circle-diameter);
        line-height: var(--circle-diameter);
        text-align: center;
        border-radius: 50%;
        background: linear-gradient(135deg, #0a7b88, #2c91a1, #36c7d7);
        font-size: 18px;
        margin: 0 20px;
        color: #fff;
      }

      .right,
      .left {
        flex: 0.35;
      }
      .container {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
      }
    }
  }
</style>
